export default __webpack_public_path__ + "static/media/share-arrow.d7d6b9ca.svg";